import { createI18n } from 'vue-i18n'
import localeMessages from './vue-i18n-locales.generated'

import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import Auth from './Mixins/Auth'

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - SP Service` : 'SP Service',
  setup({ el, App, props, plugin }) {

    const i18n = createI18n({
      mode: 'composition',
      locale: 'uk',
      fallbackLocale: 'en',
      messages: localeMessages,
    })

    createApp({render: () => h(App, props)})
      .mixin(Auth)
      .mixin({ methods: { route } })
      .use(plugin)
      .use(i18n)
      .mount(el)
  },
})
